module.exports = __webpack_public_path__ + "static/img/xnq0417.0b2de3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xnq0417.jpg
// module id = mcp2
// module chunks = 0